class CartController {
    constructor($scope, sessionStorage, settings, trolleyService, shopperService, fulfilmentService, deliveryPassService, addressService, shopPageStateService, breakpointsService, moveFocus) {
        this.settings = settings;
        this.trolleyService = trolleyService;
        this.shopperService = shopperService;
        this.fulfilmentService = fulfilmentService;
        this.addressService = addressService;
        this.scope = $scope;
        this.sessionStorage = sessionStorage;
        this.shopPageStateService = shopPageStateService;
        this.breakpointsService = breakpointsService;
        this.moveFocus = moveFocus;
    }

    $onInit() {
        const sessionStorageKey = 'wowCart:collectionZoneMessages';
        const savedMessages = this.sessionStorage.getJsonAndRemove(sessionStorageKey);

        if (!this.shopperService.IsGuest && savedMessages) {
            this.cartMessages = savedMessages;
        }

        this.scope.$on('login:success', (ev, loginResult) => {
            if (loginResult.HasCollectionZoneMessages) {
                // Save collection zone messages to session storage
                this.sessionStorage.setJson(sessionStorageKey, loginResult.LoginCollectionZoneMessages);
            }
        });
    }

    clearCart() {
        this.trolleyService.clearTrolley();
    }

    clearOutOfStock() {
        this.trolleyService.clearOutOfStockTrolleyItems();
    }

    toggleOrderManagement() {
        this.shouldShowOrderManagement = !this.shouldShowOrderManagement;
        this.moveFocus('#return-to-cart');
    }
}

const cartComponentDefinition = {
    controller: ['$scope', 'SessionStorageWrapper', 'Settings', 'TrolleyService', 'ShopperService', 'FulfilmentService', 'DeliveryPassService', 'AddressService', 'ShopPageStateService', 'BreakpointsService', 'MoveFocus', CartController],
    template: require('./cart.component.html').trim(),
};

module.exports = {
    CartController,
    cartComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart.component.js